import React from "react";
import Component from "../../../components/AscComponent";
import {Button, Container, Navbar, OverlayTrigger, Popover} from "react-bootstrap";
import "./Header.css";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faBars, faChevronDown, faChevronUp} from "@fortawesome/free-solid-svg-icons";
import AlarmSettingModal from "./AlarmSettingModal";
import NotificationSettingModal from "./NotificationSettingModal";
import MailSettingModal from "./MailSettingModal";
import { buildPlusMenuLabel } from "./plusMenuLabel";

export default class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isRecACEPlus: false,
            showAlarmModal: false,
            showNotificationModal: false,
            // アラーム設定用state
            categoryList: [],
            selectedCategories: [],
            categoryAll: false,
            incomingEnabled: true,
            outgoingEnabled: true,
            modalType: "setting",  // AscModalで使用するmodalType追加
            originalCategoryData: [], // Category API元データ保管用
            // 外部通知設定用state
            emailNotificationEnabled: false,
            emailAddress: "",
            emailList: [],
            alarmCategories: [],
            alarmCategoryAll: false,
            alarmIncomingEnabled: true,
            alarmOutgoingEnabled: true,
            alarmSettingModalShow: false,
            // メール送信設定用state
            showMailSettingModal: false
        };
    }

    /**
     * アラーム設定モーダル表示
     */
    showAlarmSettingModal = async () => {
        try {
            // カテゴリリストを取得
            const categoryResponse = await this.ascAxios('post', 'Category/board', {
                offset: 0,
                limit: 1000  // 全てのカテゴリを取得
            });
            
            // 現在のアラーム設定を取得
            const alarmResponse = await this.ascAxios('post', 'Alarm/listAlarmSettings', {});
            
            // 全カテゴリリストを作成（Select用）
            const allCategories = categoryResponse.data.rows.map(category => ({
                value: category.id,
                label: category.name,
                color: category.rgb,
                font_rgb: category.font_rgb
            }));
            
            // 現在のアラーム設定から選択されたカテゴリを抽出
            let selectedCategories = [];
            let categoryAll = false;
            let incomingEnabled = false;
            let outgoingEnabled = false;
            
            if (alarmResponse.data && alarmResponse.data.alarm_setting) {
                const alarmSetting = alarmResponse.data.alarm_setting;
                
                // category_all設定値確認
                categoryAll = alarmSetting.category_all || false;
                
                // enabledがtrueのカテゴリのみ選択状態に設定 (category_allがfalseの時のみ)
                if (!categoryAll && alarmSetting.categories && Array.isArray(alarmSetting.categories)) {
                    selectedCategories = alarmSetting.categories
                        .filter(cat => cat.enabled === true)
                        .map(cat => ({
                            value: cat.id,
                            label: cat.name,
                            color: cat.rgb
                        }));
                }
                
                // 発着信設定
                if (alarmSetting.inout_type) {
                    incomingEnabled = alarmSetting.inout_type.in || false;
                    outgoingEnabled = alarmSetting.inout_type.out || false;
                }
            }
            
            this.setState({
                showAlarmModal: true,
                categoryList: allCategories,
                selectedCategories: selectedCategories,
                categoryAll: categoryAll,
                incomingEnabled: incomingEnabled,
                outgoingEnabled: outgoingEnabled,
                modalType: "setting",
                originalCategoryData: categoryResponse.data.rows,
                alarmCategories: selectedCategories,
                alarmCategoryAll: categoryAll,
                alarmIncomingEnabled: incomingEnabled,
                alarmOutgoingEnabled: outgoingEnabled,
                alarmSettingModalShow: true
            });

        } catch (err) {
            console.error(err);
            // エラーが発生してとりあえずモーダルは表示
            this.setState({
                showAlarmModal: true,
                categoryList: [],
                selectedCategories: [],
                categoryAll: false,
                incomingEnabled: false,
                outgoingEnabled: false,
                modalType: "setting",
                originalCategoryData: [],
                alarmCategories: [],
                alarmCategoryAll: false,
                alarmIncomingEnabled: true,
                alarmOutgoingEnabled: true,
                alarmSettingModalShow: true
            });
        }
    };

    /**
     * アラーム設定モーダル閉じる
     */
    hideAlarmSettingModal = () => {
        this.setState({
            showAlarmModal: false
        });
    };

    /**
     * アラーム設定保存
     */
    saveAlarmSettings = async (settings) => {
        try {
            // APIに送るデータ形式に変換
            const selectedCategoryIds = settings.categories.map(cat => cat.value);
            
            // 全カテゴリを基準にenabledフラグ設定 (font_rgb含む)
            const categoriesWithEnabled = this.state.categoryList.map(category => {
                // Category APIから取得した元データを見つけてfont_rgb確保
                const originalCategory = this.state.originalCategoryData.find(cat => cat.id === category.value);
                return {
                    id: category.value,
                    name: category.label,
                    rgb: category.color,
                    font_rgb: originalCategory ? originalCategory.font_rgb : "#ffffff", // デフォルト値
                    enabled: selectedCategoryIds.includes(category.value)
                };
            });
            
            const requestData = {
                inout_type: {
                    in: settings.incoming,
                    out: settings.outgoing
                },
                category_all: settings.categoryAll,
                categories: categoriesWithEnabled
            };
            
            // アラーム設定を保存 (alarm_settingラッパー削除)
            await this.ascAxios('post', 'Alarm/updateAlarmSetting', requestData);
            alert(this.props.childProps.langText.Message.DataSettingSuccess);
            this.hideAlarmSettingModal();
        } catch (err) {
            console.error(err);
            alert(this.props.childProps.langText.Message.DataSettingError);
        }
    };

    handleMouseOver = event => {
        this.setState({disabled: false});
    };

    handleMouseOut = event => {
        this.setState({disabled: true});
    };

    handleLogout = async event => {
        if (window.confirm(this.props.childProps.langText.Message.LogOutConfirm)) {
            this.props.childProps.userHasAuthenticated(false);
            this.props.childProps.historyPush("/SignIn");
            await this.ascAxios("post", "/Sign/logout");
            alert(this.props.childProps.langText.Message.LogOut);
        }
    };

    /** plus メニューのラベル【#524】。規則は plusMenuLabel.js を参照 */
    getPlusMenuLabel = () => {
        const {systemParameters, langText, userInfo} = this.props.childProps;
        return buildPlusMenuLabel(systemParameters, langText, userInfo && userInfo.company_options);
    };

    getMenuList = () => {
        let permissionList = this.props.childProps.userInfo.permission_data;
        let HeaderArr = Object.keys(this.props.childProps.langText.Header);
        let RecAceAppOnly = [
            "Category",
            "ProperNoun",
            "PhoneBook",
            "AlarmSetting",
            "NotificationSetting",
            "VocHistory",
            "VocCategory"
        ];

        let menuItemArr = [];
        for(let feature of Object.keys(permissionList)){
            if (HeaderArr.find(ele => ele === feature) &&
                permissionList[feature].read === true && !RecAceAppOnly.includes(feature)) {
                menuItemArr.push(   
                    <a key={feature} href={"/"+feature} className="header-menu">{this.props.childProps.langText.Header[feature]}</a>
                );
                menuItemArr.push(
                    <hr key={feature+"hr"}/>
                );
            }
        }

        if (this.props.childProps.userInfo.options["RecAceApp"]){
            menuItemArr.push(
                <div key="RecACEPlus-menu" className="accordion-menu">
                    <div
                        onClick={() => this.setState({isRecACEPlus: !this.state.isRecACEPlus})}
                    >
                        {this.getPlusMenuLabel()}
                        <FontAwesomeIcon
                            icon={this.state.isRecACEPlus ? faChevronUp : faChevronDown}
                            className="accordion-icon"
                        />
                    </div>
                    {this.state.isRecACEPlus && (
                        <div className="accordion-content">
                            <a href="/PhoneBook" className="sub-menu">
                                {this.props.childProps.langText.Header.PhoneBook}
                            </a>
                            <hr dir="rtl" className="sub-menu-hr"/>
                            <a href="/Category" className="sub-menu">
                                {this.props.childProps.langText.Header.Category}
                            </a>
                            <hr dir="rtl" className="sub-menu-hr"/>
                            <a href="/ProperNoun" className="sub-menu">
                                {this.props.childProps.langText.Header.ProperNoun}
                            </a>
                            <hr dir="rtl" className="sub-menu-hr"/>
                            {this.props.childProps.userInfo
                                && this.props.childProps.userInfo.permission_data
                                && this.props.childProps.userInfo.permission_data.VocHistory
                                && this.props.childProps.userInfo.permission_data.VocHistory.read
                                ? (
                                    <>
                                        <a href="/VocHistory" className="sub-menu">
                                            {this.props.childProps.langText.Header.VocHistory}
                                        </a>
                                        <hr dir="rtl" className="sub-menu-hr"/>
                                    </>
                                ) : null
                            }
                            {this.props.childProps.userInfo
                                && this.props.childProps.userInfo.permission_data
                                && this.props.childProps.userInfo.permission_data.VocCategory
                                && this.props.childProps.userInfo.permission_data.VocCategory.read
                                ? (
                                    <>
                                        <a href="/VocCategory" className="sub-menu">
                                            {this.props.childProps.langText.Header.VocCategory}
                                        </a>
                                        <hr dir="rtl" className="sub-menu-hr"/>
                                    </>
                                ) : null
                            }
                            <button
                                type="button"
                                onClick={() => this.showAlarmSettingModal()}
                                className="sub-menu"
                            >
                                {this.props.childProps.langText.Header.AlarmSetting}
                            </button>
                            <hr dir="rtl" className="sub-menu-hr"/>
                            <button
                                type="button"
                                onClick={() => this.showNotificationSettingModal()}
                                className="sub-menu"
                            >
                                {this.props.childProps.langText.Header.NotificationSetting}
                            </button>
                            {(this.props.childProps.userInfo
                                && this.props.childProps.userInfo.permission_data
                                && (
                                    (this.props.childProps.userInfo.permission_data.Permission
                                        && this.props.childProps.userInfo.permission_data.Permission.level === 'system')
                                    || (this.props.childProps.userInfo.permission_data.MailSetting
                                        && this.props.childProps.userInfo.permission_data.MailSetting.read)
                                )
                            ) && (
                                <>
                                    <hr dir="rtl" className="sub-menu-hr"/>
                                    <button
                                        type="button"
                                        onClick={() => this.setState({ showMailSettingModal: true })}
                                        className="sub-menu"
                                    >
                                        {this.props.childProps.langText.Header.MailSetting}
                                    </button>
                                </>
                            )}
                        </div>
                    )}
                </div>
            );
            menuItemArr.push(
                // 【#413】同じ配列にループから key={feature+"hr"} も push されるため、
                // 万一 feature 名が "hr" でも衝突しない名前にしておく。
                <hr key={"recace-plus-hr"}/>
            );
        }

        return menuItemArr;
    }

    getUserInfo = () => {
        let userInfo = this.props.childProps.userInfo;

        return <>
            <div>
                {userInfo.sub_user_id 
                    ? this.props.childProps.langText.Body.AccountSubUserId : this.props.childProps.langText.Body.UserId}
                    : {userInfo.sub_user_id ? userInfo.sub_user_id : userInfo.user_id}
            </div>
            <hr key={"id-hr"}/>
            {userInfo.sub_user_id ? null : <div>
                <a key='account' href={"/Account"}>{this.props.childProps.langText.Header.Account}</a>
            </div>}
            {userInfo.sub_user_id ? null : <hr key={"account-hr"}/>}
        </>;
    }

    getManualDLInfo = () => {
        let userInfo = this.props.childProps.userInfo;

        return <>
            {((this.props.childProps.systemParameters.MANUAL_SETTING &&
               !(userInfo.company_options && userInfo.company_options.hideManualSetting)) ||
              (userInfo.options.RecAceApp &&
               !(userInfo.company_options && userInfo.company_options.hideManualPlus) &&
               this.props.childProps.systemParameters.MANUAL_PLUS_USER)) &&
                <div className="manual-download">
                    {this.props.childProps.systemParameters.MANUAL_SETTING &&
                     !(userInfo.company_options && userInfo.company_options.hideManualSetting) && (
                        <div>
                            <a
                                className="manual-link"
                                key="manual_setting"
                                href={this.props.childProps.systemParameters.MANUAL_SETTING}>
                                {this.props.childProps.langText.Header.ManualSetting}
                            </a>
                        </div>
                    )}
                    {userInfo.options.RecAceApp &&
                     !(userInfo.company_options && userInfo.company_options.hideManualPlus) && (
                        <>
                            <div>
                                <a
                                    className="manual-link"
                                    key="manual_plus_user"
                                    href={this.props.childProps.systemParameters.MANUAL_PLUS_USER}>
                                    {this.props.childProps.langText.Header.ManualPlusUser}
                                </a>
                            </div>
                            <div>
                                <a
                                    className="manual-link"
                                    key="manual_plus_user_web"
                                    href={this.props.childProps.systemParameters.MANUAL_PLUS_USER_WEB}>
                                    {this.props.childProps.langText.Header.ManualPlusUserWeb}
                                </a>
                            </div>
                        </>
                    )}
                </div>
            }
        </>;
    }

    /**
     * 外部通知設定モーダル表示
     */
    showNotificationSettingModal = async () => {
        try {
            // 現在の設定を取得
            const response = await this.ascAxios('post', 'Notification/listNotifications', {});
            
            let emailNotificationEnabled = false;
            let emailAddress = "";
            let emailList = [];
            
            if (response.data) {
                // mail_flagがメール通知機能の有効化の有無
                emailNotificationEnabled = response.data.mail_flag || false;
                
                // row配列をemailListに変換
                if (response.data.row && Array.isArray(response.data.row)) {
                    emailList = response.data.row.map(item => ({
                        id: item.id,
                        email_address: item.address,
                        verification_status: item.status === 'Verified' ? 'verified' : 'pending'
                    }));
                }
            }
            
            this.setState({
                showNotificationModal: true,
                emailNotificationEnabled: emailNotificationEnabled,
                emailAddress: emailAddress,
                emailList: emailList
            });
            
        } catch (err) {
            console.error(err);
            // エラーが発生してとりあえずモーダルは表示
            this.setState({
                showNotificationModal: true,
                emailNotificationEnabled: false,
                emailAddress: "",
                emailList: []
            });
        }
    };

    /**
     * 外部通知設定モーダル閉じる
     */
    hideNotificationSettingModal = () => {
        this.setState({
            showNotificationModal: false
        });
    };

    /**
     * 外部通知設定保存
     */
    saveNotificationSettings = async (settings) => {
        try {
            const requestData = {
                row: settings.row || [], // NotificationSettingModalから受け取ったrowデータを使用
                mail_flag: settings.mail_flag
            };
            
            await this.ascAxios('post', 'Notification/updateNotification', requestData);
            
            alert(this.props.childProps.langText.Message.NotificationSettingSaved);
            this.hideNotificationSettingModal();
        } catch (err) {
            console.error('Notification setting save error:', err);
            alert(this.props.childProps.langText.Message.NotificationSettingSaveFailed);
        }
    };

    /**
     * メール認証処理
     */
    handleEmailVerification = async (emailAddress) => {
        try {
            await this.ascAxios('post', 'Notification/verifyEmail', {
                email_address: emailAddress
            });
            
            alert(this.props.childProps.langText.Message.EmailVerificationSent);
            
            // メールアドレス入力欄初期化
            this.setState({
                emailAddress: ""
            });
            
            // 設定を再読み込みしてテーブルを更新
            this.showNotificationSettingModal();
        } catch (err) {
            console.error('Email verification error:', err);
            alert(this.props.childProps.langText.Message.EmailVerificationFailed);
        }
    };

    /**
     * メール削除処理
     */
    handleEmailDelete = async (emailId) => {
        if (!window.confirm(this.props.childProps.langText.Message.EmailDeleteConfirm)) {
            return;
        }
        
        try {
            await this.ascAxios('post', 'Notification/deleteEmail', {
                email_id: emailId
            });
            
            alert(this.props.childProps.langText.Message.EmailDeleteSuccess);
            
            // 設定を再読み込みしてテーブルを更新
            this.showNotificationSettingModal();
        } catch (err) {
            console.error('Email delete error:', err);
            alert(this.props.childProps.langText.Message.EmailDeleteFailed);
        }
    };

    render() {
        let popover =
            <Popover id="popover-basic">
                <Popover.Header as="h3">{this.props.childProps.systemParameters.SYSTEMTITLE}</Popover.Header>
                <Popover.Body>
                    {this.getUserInfo()}
                    {this.getMenuList()}
                    {this.getManualDLInfo()}
                    <div className="logout-button-div">
                        <Button variant="danger" className="logout-button" onClick={this.handleLogout}>
                            {this.props.childProps.langText.Body.LogOut}</Button>
                    </div>
                </Popover.Body>
            </Popover>
        return (
            <>
                <Navbar collapseOnSelect expand="lg">
                    <Container fluid>
                    <Navbar.Brand href="/">
                        <img alt = {this.props.childProps.systemParameters.SYSTEMTITLE} src = {this.props.childProps.systemParameters.HEADERLOGO}/>
                    </Navbar.Brand>
                    <OverlayTrigger rootClose="true" trigger="click" placement="left" overlay={popover}>
                        <Button variant="outline-secondary" className="toggle-btn"><FontAwesomeIcon icon={faBars}/></Button>
                    </OverlayTrigger>
                    </Container>
                </Navbar>
                {this.state.showAlarmModal && (
                    <AlarmSettingModal
                        show={this.state.showAlarmModal}
                        onHide={this.hideAlarmSettingModal}
                        categoryList={this.state.categoryList}
                        selectedCategories={this.state.selectedCategories}
                        categoryAll={this.state.categoryAll}
                        incomingEnabled={this.state.incomingEnabled}
                        outgoingEnabled={this.state.outgoingEnabled}
                        onSave={this.saveAlarmSettings}
                        langText={this.props.childProps.langText}
                        modalType={this.state.modalType}
                    />
                )}
                {this.state.showNotificationModal && (
                    <NotificationSettingModal
                        show={this.state.showNotificationModal}
                        onHide={this.hideNotificationSettingModal}
                        emailNotificationEnabled={this.state.emailNotificationEnabled}
                        emailAddress={this.state.emailAddress}
                        emailList={this.state.emailList}
                        onSave={this.saveNotificationSettings}
                        onEmailVerification={this.handleEmailVerification}
                        onEmailDelete={this.handleEmailDelete}
                        langText={this.props.childProps.langText}
                    />
                )}
                {this.state.showMailSettingModal && (
                    <MailSettingModal
                        show={this.state.showMailSettingModal}
                        onHide={() => this.setState({ showMailSettingModal: false })}
                        ascAxios={this.ascAxios}
                        langText={this.props.childProps.langText}
                    />
                )}
            </>
        );
    }
}
